import { map } from 'nanostores';

export interface PageAbTest {
	active: boolean;
	flagName: string;
	flagValue: string;
}

export const $pageAbTest = map<PageAbTest>({
	active: false,
	flagName: '',
	flagValue: '',
});
